import { callAPI } from "./core";

async function getPayment(paymentId) {
  return await callAPI(`/payment/${paymentId}`, "GET", null, true);
}

async function getPaymentInvoice(paymentId) {
  return await callAPI(`/payment/${paymentId}/invoice`, "GET", null, true);
}

async function createPaymentInvoice(paymentId) {
  return await callAPI(`/payment/${paymentId}/invoice`, "POST", null, true);
}

export { getPayment, getPaymentInvoice, createPaymentInvoice };
